<template>
  <!-- Logo container -->
  <div class="footer-logos">
    <div class="trustpilot-logo">
      <img
        class="lazyload lazy"
        src="https://cdn.trailfinders.com/trustpilotLogo.svg?width=300&amp;"
        alt="trustpilot logo"
      />
    </div>
    <div class="awards-logo">
      <img
        class="awards-logo lazyload lazy"
        src="https://cdn.trailfinders.com/images/4505880/awards26_icon_travel.png?width=160"
        alt="award winning service"
      />
    </div>
    <div class="apps-footer-container">
      <img
        class="vt-logo-footer lazyload lazy"
        src="https://cdn.trailfinders.com/vt-logo-orange-btn-colour-square.png?width=128"
      />
      <div class="store-apps">
        <a
          href="https://play.google.com/store/apps/details?id=com.trailfinders.viewtrail&amp;hl=en_GB&amp;gl=US&amp;pli=1"
          target="_blank"
        >
          <img
            class="google-store-img lazyload lazy"
            src="https://cdn.trailfinders.com/k8g3jhbctd_btn-google-play.jpg"
          />
        </a>
        <a
          href="https://apps.apple.com/gb/app/viewtrail-trailfinders/id1180019820"
          target="_blank"
        >
          <img
            class="apple-store-img lazyload lazy"
            src="https://cdn.trailfinders.com/qp0rjwat5i_btn-app-store.jpg"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
